import React from "react";

const CV = () => {
  return (
    <>
      <div className="column side"></div>
      <div className="column middle">
        <div className="inside normal">
          <span className="heading">Curriculum Vitae</span>
          <br />

          <span className="blinktext">
            (Please click{" "}
            <a
              href="https://drive.google.com/drive/folders/1cHqafxXTy9vdZmjJOiMp4qPAOHnsvZOW?usp=sharing"
              target="_blank"
              className="txtlinkflash"
            >
              here
            </a>{" "}
            for my full CV){" "}
          </span>
          <hr />
          <br />
          <span className="headingsmall">Top Honours </span>
          <ul>
              
          <li>
          Received the {" "}
                <a
                  href="https://cse.iith.ac.in/highlights/Achievements-Awards.html"
                  target="_blank"
                  className="txtlink"
                >
                  Research Excellence Award for doctoral research
                </a>{" "}
                by IIT Hyderabad<i> (2025)</i>
            </li>
            
            
          <li>
              Received the top grade "Recommended with Commendation" in the
              annual PMRF Review 2024 for the second consecutive year.<i> (2024)</i>
            </li>

            <li>
              Received the prestegious Indo-US{" "}
              <a
                href="https://www.usief.org.in/indian-fulbrighters/"
                target="_blank"
                className="txtlink"
              >
                Fulbright Doctoral Research Fellowship
              </a>{" "}
              to conduct my thesis in the United States for a period of 9
              months. <i>(2024)</i>
            </li>

            

            <li>
              Received the top grade "Recommended with Commendation" in the
              annual PMRF Review 2023 and invited to the{" "}
              <a
                href="https://www.pmrf.in/symposium-2024"
                target="_blank"
                className="txtlink"
              >
                PMRF Annual Symposium
              </a>
              . <i>(2023)</i>
            </li>

            <li>
              Received the prestegious{" "}
              <a
                href="https://www.pmrf.in/"
                target="_blank"
                className="txtlink"
              >
                Prime Minister's Research Fellowship (PMRF) for a period of 4
                years.{" "}
              </a>
              <i>(2022)</i>
            </li>

            <li>
              Won the ACM SIGCOMM 2022{" "}
              <a
                href="https://conferences.sigcomm.org/sigcomm/2022/travel-grants.html"
                target="_blank"
                className="txtlink"
              >
                Student Travel Grant
              </a>{" "}
              award. <i>(2022)</i>
            </li>
            <li>
              Won the{" "}
              <a
                href="https://www.sigmetrics.org/sigmetrics2022/student_grants.html"
                target="_blank"
                className="txtlink"
              >
                Student Grant
              </a>{" "}
              of{" "}
              <a
                href="https://www.sigmetrics.org/sigmetrics2022/"
                target="_blank"
                className="txtlink"
              >
                ACM SIGMETRICS 2022
              </a>
              . <i>(2022)</i>
            </li>
            <li>
              Won the IEEE/IFIP NOMS 2023{" "}
              <a
                href="https://noms2023.ieee-noms.org/hotel-travel/student-travel-grants"
                target="_blank"
                className="txtlink"
              >
                ComSoc student travel grant
              </a>{" "}
              <i>(2023)</i>
            </li>

            <li>
              Won the{" "}
              <a
                href="https://www.comsnets.org/archive/2022/travel_grants.html"
                target="_blank"
                className="txtlink"
              >
                COMSNETS 2022 Travel Grant
              </a>{" "}
              award. <i>(2022)</i>
            </li>
          </ul>
          <span className="headingsmall">Academic Record</span>
          <ul>
            <li>
              <b>Ph.D</b> in <i>Computer Science and Engineering</i> at the{" "}
              <a
                href="https://www.iith.ac.in/"
                target="_blank"
                className="txtlink"
              >
                Indian Institute of Technology Hyderabad
              </a>{" "}
              <b>
                <i>CGPA: 9.25</i>
              </b>
            </li>
            <li>
              <b>M.Tech</b> in <i>Computer Engineering (Cyber Security)</i> at{" "}
              <a
                href="https://nitkkr.ac.in/"
                target="_blank"
                className="txtlink"
              >
                National Institute of Technology Kurukshetra
              </a>{" "}
              <b>
                <i>CGPA: 9.14</i>
              </b>
            </li>
            <li>
              <b>B.Tech</b> in <i>Computer Science and Engineering</i> at{" "}
              <a
                href="https://www.nitpy.ac.in/"
                target="_blank"
                className="txtlink"
              >
                National Institute of Technology Puducherry
              </a>{" "}
              <b>
                <i>CGPA: 9.09</i>
              </b>
            </li>
            <li>
              <b>Higher Secondary schooling</b> from{" "}
              <a
                href="https://no1pondicherry.kvs.ac.in/"
                target="_blank"
                className="txtlink"
              >
                Kendriya Vidyalaya No. 1 JIPMER Campus
              </a>{" "}
              <b>
                <i>Percentage: 92.6%</i>
              </b>
            </li>
            <li>
              <b>Secondary schooling</b> from{" "}
              <a
                href="https://no1pondicherry.kvs.ac.in/"
                target="_blank"
                className="txtlink"
              >
                Kendriya Vidyalaya No. 1 JIPMER Campus
              </a>{" "}
              <b>
                <i>CGPA: 9.6</i>
              </b>
            </li>
          </ul>

          <span className="headingsmall">Talks and Presentations</span>
          <ul>
            <li>
              <a
                href="http://swing.iiitkottayam.ac.in/assets/pdf/Brochure_Update.pdf"
                target="_blank"
                className="txtlink"
              >
                SERB Sponsored One Week High - End Workshop on “SDN: Software
                Defined Networks Architectures and Applications”
              </a>
              : Conducted sessions on P4 prorammable dataplanes (June 2023)
            </li>
            <li>
              Presented our work "
              <a
                href="https://dl.acm.org/doi/10.1145/3600061.3600086"
                target="_blank"
                className="txtlink"
              >
                In-Network Probabilistic Monitoring Primitives under the
                Influence of Adversarial Network Inputs
              </a>
              " at{" "}
              <a
                href="https://conferences.sigcomm.org/events/apnet2023/"
                target="_blank"
                className="txtlink"
              >
                APNET 2023
              </a>
              , Hong Kong SAR. (July 2023){" "}
              <a
                href="https://dl.acm.org/doi/10.1145/3600061.3600086"
                target="_blank"
                className="txtlink"
              >
                <b>[pdf]</b>
              </a>{" "}
              <a
                href="https://conferences.sigcomm.org/events/apnet2023/slides/apnet23/Session5/Harish_APNET_23.pdf"
                target="_blank"
                className="txtlink"
              >
                <b>[slides]</b>
              </a>{" "}
              <a
                href="https://conferences.sigcomm.org/events/apnet2023/videos/session5-innet.mp4"
                target="_blank"
                className="txtlink"
              >
                <b>[talk]</b>
              </a>
            </li>
            <li>
              Presented our work "
              <a
                href="https://ieeexplore.ieee.org/document/10154376"
                target="_blank"
                className="txtlink"
              >
                Scaling IoT MUD Enforcement using Programmable Data Planes
              </a>
              " at{" "}
              <a
                href="https://noms2023.ieee-noms.org/program/technical-sessions"
                target="_blank"
                className="txtlink"
              >
                IEEE/IFIP Network Operations and Management Symposium 2023 (NOMS
                23)
              </a>
              , Miami, Florida, USA. (May 2023){" "}
              <a
                href="https://ieeexplore.ieee.org/document/10154376"
                target="_blank"
                className="txtlink"
              >
                <b>[pdf]</b>
              </a>
            </li>
            <li>
              Presented our work "
              <a
                href="https://doi.org/10.1145/3528082.3544832"
                target="_blank"
                className="txtlink"
              >
                IoT MUD Enforcement in the Edge Cloud using Programmable Switch
              </a>
              " at the{" "}
              <a
                href="https://conferences.sigcomm.org/sigcomm/2022/workshop-ffspin.html"
                target="_blank"
                className="txtlink"
              >
                FFSPIN Workshop 2023
              </a>{" "}
              as part of{" "}
              <a
                href="https://conferences.sigcomm.org/sigcomm/2022/"
                target="_blank"
                className="txtlink"
              >
                ACM SIGCOMM '22
              </a>
              , Amsterdam, Netherlands. (August 2022){" "}
              <a
                href="https://doi.org/10.1145/3528082.3544832"
                target="_blank"
                className="txtlink"
              >
                <b>[pdf]</b>
              </a>
            </li>
            <li>
              Presented our work in progress "P4 Programmable Data Plane based
              MUD Enforcement for IoT Security" at the Graduate Forum of{" "}
              <a
                href="https://perfna2022.cse.iith.ac.in/"
                target="_blank"
                className="txtlink"
              >
                PerfNA Workshop 2022
              </a>{" "}
              at{" "}
              <a
                href="https://www.sigmetrics.org/sigmetrics2022/"
                target="_blank"
                className="txtlink"
              >
                ACM SIGMETRICS 2022
              </a>{" "}
              (May 2022)
            </li>
            <li>
              Five-day workshop on Cyber Security and Cyber Forensics,{" "}
              <a
                href="https://vitap.ac.in/computer-science-engineering/"
                target="_blank"
                className="txtlink"
              >
                SCOPE
              </a>{" "}
              at{" "}
              <a
                href="https://vitap.ac.in/"
                target="_blank"
                className="txtlink"
              >
                VIT-AP University
              </a>{" "}
              (June 2021)
            </li>
          </ul>

          <span className="headingsmall">Research Collaborations</span>
          <ul>
            <li>
              <a
                href="https://www.aistic.gov.in/ASEAN/HomePage"
                target="_blank"
                className="txtlink"
              >
                ASEAN Initiative
              </a>{" "}
              at{" "}
              <a
                href="https://filkom.ub.ac.id/"
                target="_blank"
                className="txtlink"
              >
                FILKOM Brawijaya University
              </a>
              , Indonesia: Leveraging programmable data planes for scalable IoT
              security. (exchange programme){" "}<a
                href="https://filkom.ub.ac.id/2022/06/22/laboratorium-jaringan-berbasis-informasi-terima-mahasiswa-research-scholar-dari-iit-hyderabad/"
                target="_blank"
                className="txtlink"
              >
                <b>[News]</b>
              </a>
              
            </li>
            <li>
              Research exchange at{" "}
              <a
                href="https://www.cirad.fr/en/about-us/research-units/tetis"
                target="_blank"
                className="txtlink"
              >
                UMR Tetis Research Unit
              </a>
              , Montpellier, France: VWA: ViewpointS Web Application to Assess
              Collective Knowledge Building{" "}
            </li>
          </ul>
        </div>
      </div>

      <div className="column side"></div>
    </>
  );
};

export default CV;
